<script>
  import Article from '../Article.svelte';
  import LineLink from '../../common/LineLink.svelte';

  export let pinnedArticle;
  export let articles;
  export let lang = undefined;
  export let admin;

  let MAX_ARTICLES = 4;

  const i18n = {
    showAll: {
      cs: 'Zobrazit všechny články',
      en: 'Show all articles',
    },
  };

  $: if (pinnedArticle?.perex[lang]) MAX_ARTICLES = 3;
</script>

<div class='articles-box'>
  {#if pinnedArticle?.perex[lang]}
    <Article value={pinnedArticle} small={true} pinned={true} bind:lang bind:admin/>
  {/if}

  {#each articles as article, idx}
    {#if article.perex[lang] && articles.filter((article, index) => article.perex[lang] && index <= idx).length <= MAX_ARTICLES}
      <Article value={article} small={true} bind:lang bind:admin/>
    {/if}
  {/each}

  <LineLink value={i18n.showAll[lang]} link='./#/articles'/>
</div>

<style>
  .articles-box {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }
</style>
